<template>
  <div class="main-pcUltimosPalesVolcados">
    <f7-list
      v-if="ultimosPalesVolcados !== null"
      media-list
      class="content-data-list"
    >
      <f7-list-item
        v-for="(pale, i) in ultimosPalesVolcados"
        :key="i"
      >
        <div
          v-if="pale.TipoArticuloFamiliaConfeccion !== 2"
          class="content-data-list__data"
        >
          <div class="content-data-list__data--title">
            <div><span class="title"> {{ pale.ArticuloNumeroSerie ? pale.ArticuloNumeroSerie.NumeroSerie : '' }} </span></div>
            <div>
              <span
                class="subtitle"
              >
                {{
                  `${$t('common.originBatch')}: ${pale.MercanciaColaVolcado.length > 0
                    ? pale.MercanciaColaVolcado.map(mercancia => `${mercancia.Partidas.Serie} / ${mercancia.Partidas.Numero}`).join(',')
                    : ''}`
                }}
              </span>
            </div>
          </div>
          <div class="content-data-list__data--stepper">
            <small class="display-flex justify-content-center">
              {{ $t('common.packages') }}
            </small>
            <f7-stepper
              fill
              :value="0"
              :min="0"
              :max="100000"
              @input="UpdateStepperValue(pale.Id, pale.MercanciaColaVolcado, $event.target.value)"
            />
          </div>
          <!-- <div class="content-data-list__data--kilos">
                <small class="display-flex justify-content-center">
                  {{ $t('common.kilos') }}
                </small>
                <div>
                  <span class="content-kilos-number"> {{ pale.MercanciaColaVolcado.length > 0 ? pale.MercanciaColaVolcado[0].Cantidad : '' }} </span>
                </div>
              </div> -->
        </div>
        <template v-else-if="pale.MercanciaColaVolcado">
          <div
            v-for="(mercancia, k) in pale.MercanciaColaVolcado"
            :key="k"
            class="content-data-list__data"
          >
            <div class="content-data-list__data--title">
              <div><span class="title"> {{ pale.ArticuloNumeroSerie ? pale.ArticuloNumeroSerie.NumeroSerie : '' }} </span></div>
              <div>
                <span class="subtitle">
                  {{ `${$t('common.originBatch')}: ${mercancia.Partidas.Serie} / ${mercancia.Partidas.Numero}` }}
                </span>
              </div>
            </div>
            <div class="content-data-list__data--stepper">
              <small class="display-flex justify-content-center">
                {{ $t('common.packages') }}
              </small>
              <f7-stepper
                fill
                :value="0"
                :min="0"
                :max="10000"
                :step="1"
                @input="UpdateStepperValue(pale.Id, [mercancia], $event.target.value)"
              />
            </div>
            <!-- <div class="content-data-list__data--kilos">
                  <small class="display-flex justify-content-center">
                    {{ $t('common.kilos') }}
                  </small>
                  <div>
                    <span class="content-kilos-number"> {{ mercancia.Partidas.Cantidad }} </span>
                  </div>
                </div> -->
          </div>
        </template>
      </f7-list-item>
    </f7-list>
  </div>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import {
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import { callExecuteSPERP } from '@/js/services/APIErp';

export default {
  name: 'PCUltimosPalesVolcados',

  emits: ['valores-stepper'],

  data() {
    return {
      valoresStepper: {},
    };
  },

  computed: {
    ...mapState(useTraceabilityStore, [
      'datosOrigenPale',
      'puntoDePaletizadoSeleccionado',
      'ultimosPalesVolcados',
    ]),

    ...mapWritableState(useTraceabilityStore, ['ultimosPalesVolcados']),
  },

  methods: {
    UpdateStepperValue(idPale, mercancia, value) {
      Log(this, this.UpdateStepperValue.name);
      mercancia.forEach((m) => {
        this.valoresStepper[`${idPale}-${m.Partidas.Id}`] = Number.parseInt(value, 10);
      });

      this.$emit('valores-stepper', this.valoresStepper);
    },

    FiltrarPalesVolcados(data) {
      Log(this, this.FiltrarPalesVolcados.name);
      this.valoresStepper = {};

      if (this.datosOrigenPale !== null && this.datosOrigenPale.length > 0) {
        const resultMap = new Map();
        this.datosOrigenPale.forEach((elemento) => {
          const key = elemento.ArticuloNumeroSerie.NumeroSerie;

          elemento.ArticuloNumeroSerie.DatosOrigen.forEach((mercancia) => {
            if (resultMap.has(key)) {
              const existingValues = resultMap.get(key);
              const newValue = `${existingValues},${mercancia.Partida.Id}`;
              resultMap.set(key, newValue);
            } else {
              resultMap.set(key, `${mercancia.Partida.Id}`);
            }
          });
        });

        let res = [];
        const resultado = [];

        data.forEach((elemento) => {
          const articuloNumeroSerie = elemento.ArticuloNumeroSerie.NumeroSerie;
          const partidas = elemento.MercanciaColaVolcado.map((mercancia) => mercancia.Partidas.Id);

          if (resultMap.has(articuloNumeroSerie)) {
            const existingValues = resultMap.get(articuloNumeroSerie).split(',');
            const valores = existingValues.map((cadena) => Number.parseInt(cadena, 10));

            partidas.forEach((v) => {
              if (!valores.includes(v)) {
                const r = elemento.MercanciaColaVolcado.filter((f) => f.Partidas.Id === v);
                res = { ...elemento, MercanciaColaVolcado: r };
                resultado.push(res);
              } else {
                resultado.push(elemento);
              }
            });
          } else {
            resultado.push(elemento);
          }
        });

        this.ultimosPalesVolcados = resultado;
      } else {
        this.ultimosPalesVolcados = data;
      }
    },

    // ********************* CONEXIONES *************************** \\

    /**
     * @public
     * @param {number} idArticulo
     * @returns {Promise<void>}
     */
    async Conections_GetOverturnedPpallet(idArticulo) {
      Log(this, this.Conections_GetOverturnedPpallet.name);
      this.ultimosPalesVolcados = null;
      PreloaderGH(true, false, this.$t('common.loading'));
      try {
        const result = await callExecuteSPERP('APPTRAZABILIDAD_VolcadosXPuntoPaletXArtConfSegunTiposFamilia', [
          { NombreParametro: 'idArticuloConfeccionado', Valor: idArticulo },
          { NombreParametro: 'idPuntoPaletizado', Valor: this.puntoDePaletizadoSeleccionado.Id },
          { NombreParametro: 'numeroDiasConsulta', Valor: 30 },
        ], 'Trazabilidad.VolcadosPorArticuloNumeroSerieJSON');
        if (result.statusText === 'OK' || result.status === 200) {
          this.FiltrarPalesVolcados(result.data);
          PreloaderGH(false);
        }
      } catch (error) {
        PreloaderGH(false);
        LogError(this, this.Conections_GetOverturnedPpallet.name, error);
      }
      PreloaderGH(false);
    },
  },
};
</script>

<style lang="scss">
.main-pcUltimosPalesVolcados {
  background-color: #fff;
  height: calc(100% - var(--f7-navbar-height) - 45px);

  .content-data-list {
    overflow-y: scroll;
    border: 1px solid var(--his-silver);

    &__data {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding-right: 40px;

      &--title {
        justify-content: center;
        display: flex;
        flex-direction: column;

        span {
          -webkit-box-orient: vertical;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
        }

        .title {
          color: var(--his-steel-blue);
          font-size: 18px;
          font-weight: 600;
        }

        .subtitle {
          color: var(--his-darkgray);
          font-size: 14px;
          font-weight: 500;
        }
      }

      &--kilos {
        display: flex;
        flex-direction: column;
        align-items: center;

        .content-kilos-number {
          font-size: 32px;
        }
      }

      &--delete {
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
